export const pakistanCities = {
  popular: [
    "Lahore",
  ],
  cities: [
    
  ]
};
